<template>
    <div>
        <div v-if="showEdit == false">
            <b-overlay :show="isLoading">
                <b-row>
                    <b-col cols="12" class="mb-2">
                        <b-button variant="success">Add SoP</b-button>
                    </b-col>
                    <b-col>
                        <webix-ui :config="ui" v-model="sop"></webix-ui>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col>
                        <b-button @click="editSOP" variant="primary">Edit SOP</b-button>
                    </b-col>
                </b-row>
            </b-overlay>
        </div>
        <div v-else >
            <EditSop @back="back" />
        </div>
    </div>
</template>

<script>
import EditSop from './sopEdit.vue'
export default {
    components:{
        EditSop,
    },
    data:() => ({
        isLoading: false,
        sop:[],
        showEdit: false,
        ui:{
            id: 'sopTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns:[
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"group", header:"SOP Group", fillspace: true},
                { id:"name", header:"Name", fillspace:1},
                { id:"code", header:"Code", fillspace:1},
                { id:"description", header:"Description", fillspace:1},
                { id:"revision", header:"Revision", fillspace:1},
                { id:"date_modified", header:"Date Modified", fillspace:1},
                { id:"actions", header:"Actions", fillspace:1},
            ],
            on: {
                onItemClick(id){
                    var item = this.getItem(id)
                    console.log(item);
                }
            },
            onClick:{},
        },
    }),
    computed:{},
    methods:{
        editSOP(){
            this.isLoading = true;
            setTimeout(()=>{
                //* load sop data
                this.showEdit = true;
            },50)
        },
        back(){
            this.isLoading = false;
            this.showEdit = false;
        }
    },
    mounted(){},
}
</script>

<style>

</style>